import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { ArrowRight, ExternalLink } from "lucide-react";
import { DotGrid } from "@/components/marketing/DotGrid";

const APPSOURCE_URL = "https://marketplace.microsoft.com/en-us/product/WA200010021?tab=Overview";

export const CTA = () => {
  const { ref, animationClass } = useScrollAnimation<HTMLDivElement>({
    type: "scale",
    threshold: 0.2,
  });

  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container px-4">
        <div
          ref={ref}
          className={`relative overflow-hidden rounded-2xl bg-[hsl(213_35%_12%)] p-10 md:p-16 lg:p-20 text-center shadow-fluent-32 ring-1 ring-white/10 ${animationClass}`}
        >
          <div className="absolute inset-0 opacity-100">
            <DotGrid fade="radial" tone="light" />
          </div>
          <div className="relative max-w-2xl mx-auto">
            <span className="text-[11px] font-mono uppercase tracking-widest text-white/80">
              Get started
            </span>
            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl mt-3 mb-5 text-white">
              Stop copy-pasting. Start saving contacts.
            </h2>
            <p className="text-base md:text-lg text-white/85 mb-9">
              Available now on Microsoft AppSource. Install in 60 seconds.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button size="lg" asChild className="shadow-fluent-16 group bg-white text-[hsl(213_35%_12%)] hover:bg-white/90">
                <a
                  href={APPSOURCE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2"
                >
                  Get it on AppSource
                  <ExternalLink className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </Button>
              <Button
                size="lg"
                variant="ghost"
                asChild
                className="text-white hover:bg-white/15 border border-white/30"
              >
                <Link to="/pricing" className="inline-flex items-center gap-2">
                  View plans <ArrowRight className="w-4 h-4" />
                </Link>
              </Button>
            </div>

            <p className="mt-8 text-xs font-mono uppercase tracking-widest text-white/60">
              Works inside Outlook · No credit card required
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
